// Uniswap V3 on Base L2 — addresses, fee tiers and minimal ABIs.
// All values verified on-chain (factory.getPool) on 2026-06-10:
//   RBL/WETH pool (fee 10000 = 1%)  -> 0xe233d50505fd308aac8703aeba554f7de593e8f7
//   USDC/WETH pool (fee 500 = 0.05%) -> 0xd0b53d9277642d899df5c87a3966a349a798f224

export const WETH_BASE = "0x4200000000000000000000000000000000000006";
export const USDC_BASE = "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913";
export const RBL_BASE = "0xf9214b42c4c53791846E90066E52D7306adFACf5";

export const UNISWAP_QUOTER_V2_BASE = "0x3d4e44Eb1374240CE5F1B871ab261CD16335B76a";
export const UNISWAP_SWAP_ROUTER_02_BASE = "0x2626664c2603336E57B271c5C0b26F421741e481";

export const FEE_RBL_WETH = 10000; // 1%
export const FEE_USDC_WETH = 500; // 0.05%

export const erc20Abi = [
  {
    name: "balanceOf",
    type: "function",
    stateMutability: "view",
    inputs: [{ name: "owner", type: "address" }],
    outputs: [{ name: "", type: "uint256" }],
  },
  {
    name: "allowance",
    type: "function",
    stateMutability: "view",
    inputs: [
      { name: "owner", type: "address" },
      { name: "spender", type: "address" },
    ],
    outputs: [{ name: "", type: "uint256" }],
  },
  {
    name: "approve",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      { name: "spender", type: "address" },
      { name: "amount", type: "uint256" },
    ],
    outputs: [{ name: "", type: "bool" }],
  },
];

// QuoterV2 — struct order is (tokenIn, tokenOut, amountIn, fee, sqrtPriceLimitX96).
// Declared as `view` so it can be invoked via eth_call by useReadContract.
export const quoterV2Abi = [
  {
    name: "quoteExactInputSingle",
    type: "function",
    stateMutability: "view",
    inputs: [
      {
        name: "params",
        type: "tuple",
        components: [
          { name: "tokenIn", type: "address" },
          { name: "tokenOut", type: "address" },
          { name: "amountIn", type: "uint256" },
          { name: "fee", type: "uint24" },
          { name: "sqrtPriceLimitX96", type: "uint160" },
        ],
      },
    ],
    outputs: [
      { name: "amountOut", type: "uint256" },
      { name: "sqrtPriceX96After", type: "uint160" },
      { name: "initializedTicksCrossed", type: "uint32" },
      { name: "gasEstimate", type: "uint256" },
    ],
  },
  {
    name: "quoteExactInput",
    type: "function",
    stateMutability: "view",
    inputs: [
      { name: "path", type: "bytes" },
      { name: "amountIn", type: "uint256" },
    ],
    outputs: [
      { name: "amountOut", type: "uint256" },
      { name: "sqrtPriceX96AfterList", type: "uint160[]" },
      { name: "initializedTicksCrossedList", type: "uint32[]" },
      { name: "gasEstimate", type: "uint256" },
    ],
  },
];

// SwapRouter02 — NO deadline field in the param structs (verified: bytecode
// contains selectors 0x04e45aaf / 0xb858183f, not the legacy 0x414bf389).
export const swapRouter02Abi = [
  {
    name: "exactInputSingle",
    type: "function",
    stateMutability: "payable",
    inputs: [
      {
        name: "params",
        type: "tuple",
        components: [
          { name: "tokenIn", type: "address" },
          { name: "tokenOut", type: "address" },
          { name: "fee", type: "uint24" },
          { name: "recipient", type: "address" },
          { name: "amountIn", type: "uint256" },
          { name: "amountOutMinimum", type: "uint256" },
          { name: "sqrtPriceLimitX96", type: "uint160" },
        ],
      },
    ],
    outputs: [{ name: "amountOut", type: "uint256" }],
  },
  {
    name: "exactInput",
    type: "function",
    stateMutability: "payable",
    inputs: [
      {
        name: "params",
        type: "tuple",
        components: [
          { name: "path", type: "bytes" },
          { name: "recipient", type: "address" },
          { name: "amountIn", type: "uint256" },
          { name: "amountOutMinimum", type: "uint256" },
        ],
      },
    ],
    outputs: [{ name: "amountOut", type: "uint256" }],
  },
];

/** amountOutMinimum with slippage in basis points (100 bps = 1%). */
export function applySlippage(amountOut, slippageBps) {
  return (amountOut * (10000n - BigInt(slippageBps))) / 10000n;
}
